import React from 'react';

export default function Card({ children, className = '', hover = false }) {
  const base = 'bg-white dark:bg-slate-800 rounded-[12px] border border-[#e2e8f0] dark:border-slate-700 shadow-[0_4px_12px_rgba(0,0,0,0.05)] overflow-hidden transition duration-200';
  const hoverClass = hover ? 'hover:shadow-md hover:border-[#0ea5e9]/30' : '';
  return (
    <div className={`${base} ${hoverClass} ${className}`} style={{ animation: 'fadeInUp 0.25s ease-out' }}>
      {children}
    </div>
  );
}

export function CardHeader({ title, subtitle, className = '' }) {
  return (
    <div className={`px-5 py-4 border-b border-[#e2e8f0] dark:border-slate-700 bg-slate-50/80 dark:bg-slate-800/80 ${className}`}>
      <h2 className="text-base font-semibold text-[#0f172a] dark:text-slate-100">{title}</h2>
      {subtitle && <p className="text-sm text-[#475569] dark:text-slate-400 mt-0.5">{subtitle}</p>}
    </div>
  );
}
